import { getList, getDetails } from "@/api/solutionScheme";
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataListLoading: false,
  },
  mutations: {
    setDataList(state, list) {
      state.dataList = list || [];
    },
    setDataListLoading(state, loading) {
      state.dataListLoading = loading
    }
  },
  actions: {
    getDataList({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        if (state.dataListLoading) return;
        commit('setDataListLoading', true);
        getList(params).then(res => {
          if (res && res.data && res.data.list) {
            resolve(res.data)
            commit('setDataList', res.data.list);
          } else {
            commit('setDataList', []);
          }
        }).catch(error => {
          reject(error)
        }).finally(commit('setDataListLoading', false))
      });
    }
  }
}
